// Petit bip + vibration sans fichier audio (WebAudio) — utilisé pour les appels serveuse / nouvelles commandes
let ctx = null;

export const playBeep = (pattern = "call") => {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    const notes = pattern === "call" ? [[880, 0], [1175, 0.18]] : [[660, 0], [660, 0.22]];
    notes.forEach(([freq, delay]) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.value = freq;
      g.gain.setValueAtTime(0.0001, ctx.currentTime + delay);
      g.gain.exponentialRampToValueAtTime(0.4, ctx.currentTime + delay + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + delay + 0.18);
      o.connect(g).connect(ctx.destination);
      o.start(ctx.currentTime + delay);
      o.stop(ctx.currentTime + delay + 0.2);
    });
  } catch {}
  try { navigator.vibrate?.(pattern === "call" ? [200, 100, 200] : [120]); } catch {}
};
